import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useRouter } from 'next/router'
import { BadRequest } from 'shared/errors/bad-request'
import { register } from 'modules/authentication/api/register-api'
import { RegisterFormInterface } from 'modules/authentication/types/post-register-interface'

export const useRegisterForm = () => {
  const router = useRouter()
  const [isLoading, setIsLoading] = useState(false)
  const {
    handleSubmit,
    control,
    setValue,
    setError,
    formState: { errors },
    clearErrors,
  } = useForm<RegisterFormInterface>()

  // Need for autocomplete in firefox
  useEffect(() => {
    document.addEventListener('animationstart', event => {
      if (event.animationName === 'onAutoFill') {
        const input = event.target as HTMLInputElement
        setValue(input.name as keyof RegisterFormInterface, input.value)
      }
    })
  }, [])

  useEffect(() => {
    clearErrors()
  }, [router.locale])

  const onSubmit = async (values: RegisterFormInterface) => {
    try {
      setIsLoading(true)
      const response = await register({ email: values.email })
      const redirect = response?.data?.redirect || '/thank-you'
      router.push(redirect, redirect, { locale: false })
    } catch (e) {
      if (e instanceof BadRequest) {
        const { fields, common } = e.errors || {}
        if (fields) {
          setError('email', { message: fields?.email.join('\n') })
        }
        if (common) {
          setError('root', { message: common?.join('\n') })
        }
      }
    } finally {
      setIsLoading(false)
    }
  }

  return {
    handleSubmit,
    control,
    setValue,
    errors,
    isLoading,
    onSubmit,
  }
}
